import { render, staticRenderFns } from "./dg-contact.vue?vue&type=template&id=87df7960&scoped=true"
import script from "./dg-contact.vue?vue&type=script&lang=js"
export * from "./dg-contact.vue?vue&type=script&lang=js"
import style0 from "./dg-contact.vue?vue&type=style&index=0&id=87df7960&prod&lang=less&scoped=true"
import style1 from "./dg-contact.vue?vue&type=style&index=1&id=87df7960&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87df7960",
  null
  
)

export default component.exports